import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedHTMLMessage } from 'react-intl';

import NotFoundError from 'components/Errors/NotFoundError';

const FooterLinkPage = ({ intl, match }) => {
  function messageId() {
    let id = `footerPage.${ match.params.pageType }`;
    if (match.params.pageType === 'eula') {
      id = 'eula';
    }
    return id;
  }

  function contentExists() {
    const msgId = messageId();
    return intl
      && intl.formatMessage({ id: msgId }) !== msgId
      && !!intl.formatMessage({ id: msgId });
  }

  return <section className="container footer-page mt-5">
    { contentExists() && <FormattedHTMLMessage id={ messageId() } /> }
    { !contentExists() && <NotFoundError /> }
  </section>;
};

FooterLinkPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      pageType: PropTypes.string
    })
  }).isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired
};

export default (injectIntl(FooterLinkPage));
